"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _OvhCloud = /*#__PURE__*/ _interop_require_default(require("./OvhCloud"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let OvhCloudPlugin = class OvhCloudPlugin extends _ncplugin.XcStoragePlugin {
    getAdapter() {
        return OvhCloudPlugin.storageAdapter;
    }
    async init(config) {
        OvhCloudPlugin.storageAdapter = new _OvhCloud.default(config);
        await OvhCloudPlugin.storageAdapter.init();
    }
};
const _default = OvhCloudPlugin;
